import 'whatwg-fetch';

var configuration = { };

const csharpExceptionReader = (result, response) => {
  if (result.exceptionMessage && result.exceptionType && result.stackTrace) {
    let error = new Error(result.exceptionMessage);

    error.serverTechnology = 'C#';
    error.exceptionType = result.exceptionType;
    error.stackTrace = result.stackTrace;

    return error;
  } else {
    return rawException(result.message || result.error, response);
  }
};

const jsonException = (text, response) => {
  try {
    return csharpExceptionReader(JSON.parse(text), response);
  } catch (error) {
    return rawException(text, response);
  }
};

const rawException = (text, response) => {
  let error;

  if (text) {
    error = new Error(response.statusText + ' ' + text);
  } else {
    error = new Error(response.statusText);
  }

  error.response = response;
  return error;
};

export const configureFetch = conf => {
  configuration = {
    ...configuration,
    ...conf
  };

  if (configuration.authorization && !conf.authorization) {
    console.debug('Dismissed authorization token');
  }
};

export default function (url, options = {}) {
  if (!options.headers) {
    options.headers = {
      'Content-Type': 'application/json'
    };
  }

  if (configuration.authorization) {
    options.headers['Authorization'] = configuration.authorization;
  }

  if (options.bodyIsForm) {
    options.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
    options.body = Object.keys(options.body)
      .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(options.body[key]))
      .join('&');
  }

  if (!options.headers['Content-Type'] && options.hasOwnProperty('body')) {
    options.headers['Content-Type'] = 'application/json';
  }

  if (options.headers['Content-Type'] === 'application/json' && typeof options.body !== 'string') {
    options.body = JSON.stringify(options.body);
  }

  options.bodyIsForm = undefined;

  return fetch(configuration.apiRootUrl + '/' + url, options)
    .then(response => {
      if (!response.ok) {
        throw response;
      }

      if (options.expect === 'text') {
        return response.text();
      } 
      
      if (options.expect === 'blob') { 
        return response.blob();
      }
      
      return response.json();
    })
    .catch(response => {
      if (typeof response.ok === 'boolean') {
        return response.text()
          .then(text => {
            let error;

            try {
              error = jsonException(text, response);
            } catch (e) {
              error = rawException('', response);
            }

            throw error;
          });
      } else {
        throw new Error('Error: Comprueba tu conexión a internet');
      }
    })
};

export const originalFetch = fetch;



// WEBPACK FOOTER //
// ./actions/lib/fetch.js